export const joinPath = (paths: string[]) => {
  return (
    paths
      .join('/')
      // remove double (and tripple, etc) slashes
      .replace(/\/{2,}/g, '/')
      // remove trailing slash as long as its not the first character
      .replace(/(.{1})\/$/, '$1')
  );
};
